<template>
  <div class="client-grouping-pane client-grouping-ungrouped">
    <div class="table">
      <el-table :data="tableData" border size="small" style="width: 100%">
        <el-table-column prop="brokerName" label="经纪商名称" />
        <el-table-column prop="userCode" label="登录账户" />
        <el-table-column prop="userName" label="登录姓名" />
        <el-table-column prop="userTypeName" label="账户类型" />
      </el-table>
    </div>
    <div class="page_box">
      <div class="msg_count">共&nbsp;{{ listTotal }}&nbsp;条</div>
      <div class="blank"></div>
      <div class="page">
        <el-pagination
          v-if="showListPagination"
          background
          layout="prev, pager, next"
          :total="listTotal"
          :page-size="listPageSize"
          :current-page="listPageNo"
          @current-change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
/** 未分组账户分页列表 */
import '@/view/user/eval_jees/style.css';
import { normalizeDirectListRow } from '@/view/user/eval_jees/ctp_direct/normalizeDirectListRow';
import { groupingAccountTypeLabel } from './groupingAccountType';

const LIST_PAGE_SIZE = 1000;

function extractUngroupedListPayload(resBody) {
  if (!resBody || resBody.code != 200 && resBody.code != '200') {
    return { records: [], total: 0 };
  }
  const d = resBody.data;
  if (Array.isArray(d)) {
    return { records: d, total: d.length };
  }
  if (d && typeof d === 'object') {
    if (Array.isArray(d.records)) {
      return {
        records: d.records,
        total: Number(d.total) != null && !Number.isNaN(Number(d.total))
          ? Number(d.total)
          : d.records.length,
      };
    }
    if (Array.isArray(d.list)) {
      return {
        records: d.list,
        total:
          Number(d.total) != null && !Number.isNaN(Number(d.total))
            ? Number(d.total)
            : d.list.length,
      };
    }
  }
  if (Array.isArray(resBody.datas)) {
    return { records: resBody.datas, total: resBody.datas.length };
  }
  return { records: [], total: 0 };
}

/** 未分组：先 normalize（经纪商等），杰宜斯类再覆盖类型与经纪商「-」 */
function mapUngroupedRow(raw) {
  const row = normalizeDirectListRow(raw);
  const ut = Number(raw.userType);
  if (ut >= 1 && ut <= 3) {
    return {
      ...row,
      brokerName: '-',
      serverManageName: '-',
      userTypeName: groupingAccountTypeLabel(raw),
    };
  }
  return row;
}

export default {
  name: 'ClientGroupingUngroupedList',
  props: {
    /** 与「未分组」Tab 同步，为 true 时拉取列表 */
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableData: [],
      listTotal: 0,
      listPageNo: 1,
      listPageSize: LIST_PAGE_SIZE,
    };
  },
  computed: {
    showListPagination() {
      return this.listTotal >= this.listPageSize;
    },
  },
  watch: {
    active: {
      immediate: true,
      handler(v) {
        if (v) {
          this.loadList();
        }
      },
    },
  },
  methods: {
    apiToken() {
      try {
        const t = JSON.parse(localStorage.getItem('token') || '{}');
        return t.apiToken || this.$store.state.usermsg.apiToken;
      } catch (e) {
        return this.$store.state.usermsg.apiToken;
      }
    },
    buildQueryBody() {
      return {
        token: this.apiToken(),
        page_no: this.listPageNo,
        size: this.listPageSize,
      };
    },
    loadList() {
      if (!this.active) {
        return;
      }
      this.$request
        .post('/api_eval/direct_ungrouped_list', this.buildQueryBody(), { skipToken: true, rawResponse: true })
        .then((res) => {
          this.tokenInvalid(res);
          if (res.data && res.data.code == 200) {
            const { records, total } = extractUngroupedListPayload(res.data);
            this.listTotal = Number(total) || 0;
            const maxPage = Math.max(
              1,
              Math.ceil(this.listTotal / this.listPageSize) || 1
            );
            if (this.listPageNo > maxPage && this.listTotal > 0) {
              this.listPageNo = maxPage;
              this.loadList();
              return;
            }
            this.tableData = (records || []).map(mapUngroupedRow);
          } else {
            this.tableData = [];
            this.listTotal = 0;
            const msg =
              (res.data && (res.data.message || res.data.msg)) || '加载失败';
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.tableData = [];
          this.listTotal = 0;
          this.$message.error('网络异常，请稍后重试');
        });
    },
    onPageChange(page) {
      this.listPageNo = page;
      this.loadList();
    },
  },
};
</script>

<style scoped>
.client-grouping-ungrouped .page_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.client-grouping-ungrouped .msg_count {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #00192f;
}
.client-grouping-ungrouped .blank {
  flex: 1;
  min-width: 8px;
}
</style>



// WEBPACK FOOTER //
// src/view/client/grouping/UngroupedList.vue